import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Osoba } from '../models';
// @ts-ignore
import { OsobaOrganizacieCreate } from '../models';
/**
 * OsobyApi - axios parameter creator
 * @export
 */
export const OsobyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {OsobaOrganizacieCreate} osobaOrganizacieCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalCreateOsobaOrganizacieOsoby: async (osobaOrganizacieCreate: OsobaOrganizacieCreate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'osobaOrganizacieCreate' is not null or undefined
            assertParamExists('portalCreateOsobaOrganizacieOsoby', 'osobaOrganizacieCreate', osobaOrganizacieCreate)
            const localVarPath = `/osoby/osoby-organizacie`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(osobaOrganizacieCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získanie osoby (iba pre platne priradené do subjektu)
         * @param {string} osobaId Osoba ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetOsobaOsoby: async (osobaId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'osobaId' is not null or undefined
            assertParamExists('portalGetOsobaOsoby', 'osobaId', osobaId)
            const localVarPath = `/osoby/{osobaId}`
                .replace(`{${"osobaId"}}`, encodeURIComponent(String(osobaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Editácia osoby (iba pre platne priradené do subjektu)
         * @param {string} osobaId Osoba ID
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalUpdateOsobaOsoby: async (osobaId: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'osobaId' is not null or undefined
            assertParamExists('portalUpdateOsobaOsoby', 'osobaId', osobaId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('portalUpdateOsobaOsoby', 'body', body)
            const localVarPath = `/osoby/{osobaId}`
                .replace(`{${"osobaId"}}`, encodeURIComponent(String(osobaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OsobyApi - functional programming interface
 * @export
 */
export const OsobyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OsobyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {OsobaOrganizacieCreate} osobaOrganizacieCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalCreateOsobaOrganizacieOsoby(osobaOrganizacieCreate: OsobaOrganizacieCreate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Osoba>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalCreateOsobaOrganizacieOsoby(osobaOrganizacieCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Získanie osoby (iba pre platne priradené do subjektu)
         * @param {string} osobaId Osoba ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalGetOsobaOsoby(osobaId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Osoba>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalGetOsobaOsoby(osobaId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Editácia osoby (iba pre platne priradené do subjektu)
         * @param {string} osobaId Osoba ID
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalUpdateOsobaOsoby(osobaId: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Osoba>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalUpdateOsobaOsoby(osobaId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OsobyApi - factory interface
 * @export
 */
export const OsobyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OsobyApiFp(configuration)
    return {
        /**
         * 
         * @param {OsobaOrganizacieCreate} osobaOrganizacieCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalCreateOsobaOrganizacieOsoby(osobaOrganizacieCreate: OsobaOrganizacieCreate, options?: any): AxiosPromise<Osoba> {
            return localVarFp.portalCreateOsobaOrganizacieOsoby(osobaOrganizacieCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získanie osoby (iba pre platne priradené do subjektu)
         * @param {string} osobaId Osoba ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetOsobaOsoby(osobaId: string, options?: any): AxiosPromise<Osoba> {
            return localVarFp.portalGetOsobaOsoby(osobaId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Editácia osoby (iba pre platne priradené do subjektu)
         * @param {string} osobaId Osoba ID
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalUpdateOsobaOsoby(osobaId: string, body: object, options?: any): AxiosPromise<Osoba> {
            return localVarFp.portalUpdateOsobaOsoby(osobaId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OsobyApi - object-oriented interface
 * @export
 * @class OsobyApi
 * @extends {BaseAPI}
 */
export class OsobyApi extends BaseAPI {
    /**
     * 
     * @param {OsobaOrganizacieCreate} osobaOrganizacieCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OsobyApi
     */
    public portalCreateOsobaOrganizacieOsoby(osobaOrganizacieCreate: OsobaOrganizacieCreate, options?: AxiosRequestConfig) {
        return OsobyApiFp(this.configuration).portalCreateOsobaOrganizacieOsoby(osobaOrganizacieCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získanie osoby (iba pre platne priradené do subjektu)
     * @param {string} osobaId Osoba ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OsobyApi
     */
    public portalGetOsobaOsoby(osobaId: string, options?: AxiosRequestConfig) {
        return OsobyApiFp(this.configuration).portalGetOsobaOsoby(osobaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Editácia osoby (iba pre platne priradené do subjektu)
     * @param {string} osobaId Osoba ID
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OsobyApi
     */
    public portalUpdateOsobaOsoby(osobaId: string, body: object, options?: AxiosRequestConfig) {
        return OsobyApiFp(this.configuration).portalUpdateOsobaOsoby(osobaId, body, options).then((request) => request(this.axios, this.basePath));
    }
}
